<template>
  <div class="w-full relative flex flex-col space-y-1.5 pb-2.5 rounded px-3">
    <div v-if="getCurrentDiscussion.currently_active" :class="{'mt-9':isFullscreen}"  class="w-10 h-10 flex items-center justify-center bg-lightBlue-200 rounded-full py-2 cursor-pointer relative overflow-visible">
      <div @click="handleOpenParticipantAssessment(currentSpeaker)" class="w-7 relative h-7 rounded-full overflow-hidden speaking">
        <img class="rounded-full" :src="currentSpeaker.user.avatar_url"/>
      </div>
    </div>
    <div>
      <ul v-for="(studentInCircle, index) in usersInCircle" :key="index">
        <li 
          @click="openParticipantFromTapIn(studentInCircle.participation.user.id)" 
          :title="studentInCircle.participation.user.name" 
          @mouseenter="isHoveringStudent = studentInCircle.participation.user.id" 
          @mouseleave="isHoveringStudent = null" 
          v-if="studentInCircle.participation.user.id !== getCurrentDiscussion.currently_active" 
          class="hover:bg-gray-200 cursor-pointer rounded-full w-10 h-10 flex items-center justify-center mb-1"
        >
          <div class="w-7 relative h-7 rounded-full ring-2 ring-yellow-400 ring-offset-2">
            <img class="rounded-full" :src="studentInCircle.participation.user.avatar_url"/>
          </div>
        </li>
      </ul>
      <ul class="-mb-1">
        <li v-for="(student, index) in studentsFiltered" :key="index">
          <div 
            :title="student.user.name" 
            v-if="isStudentOnline(student.user_id) && isStudentNotInCircle(student.user_id) && student.user_id !== getCurrentDiscussion.currently_active" 
            class="py-2 hover:bg-gray-100 rounded-full px-2 cursor-pointer mb-1"
          >
            <div class="w-7 relative h-7 rounded-full ring-2 ring-green-600 ring-offset-2">
              <img class="rounded-full" :src="student.user.avatar_url"/>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { clearAllTapIns, addStudentToCircle } from 'services/liveDiscussion/circle/circleServices.js';
  import toggleStudentParticipationAudio from 'services/liveDiscussion/toggleStudentParticipationAudio.js';
  import toggleStudentParticipationVideo from 'services/liveDiscussion/toggleStudentParticipationVideo.js';
  import { EventBus } from 'utils/event-bus';

  export default Vue.extend({
    components: {
      Actions: () => import('./Actions.vue'),
    },
    data() {
      return {
        searchStudents: '',
        isOfflineMenuOpen: true,
        isOnlineMenuOpen: true,
        isSearchBoxOpen: false,
        activeTapInOption: null,
        tapin: false,
        isHoveringStudent: null
      };
    },
    computed: {
      ...mapGetters([
        'getLiveDiscussionMagicLink',
        'getCurrentDiscussion',
        'hasTeacherPermissionsInCourse',
        'getCourseLayoutFullScreenStatus',
        'getQueue',
        'getStudentsInCourse',
      ]),
      studentsFiltered: function () {
        const participations = this.getCurrentDiscussion.participations;
        if (!this.searchStudents) return participations;
        return participations.filter((p) => {
          if (p.user.name)
            return p.user.name
              .toLowerCase()
              .includes(this.searchStudents.toLowerCase());
        });
      },
      studentsOffline() {
        let offlineCount = 0;
        const participations = this.getCurrentDiscussion.participations;
        participations.forEach((p) => {
          if (
            !this.isStudentOnline(p.user.id) &&
            this.isStudentNotInCircle(p.user.id)
          )
            offlineCount += 1;
        });
        return offlineCount;
      },
      studentsOnline() {
        let onlineCount = 0;
        this.getCurrentDiscussion.participations.forEach((participation) => {
          let isInCircle = this.getCurrentDiscussion.turns_in_circle.filter(
            (t) =>
              t.participation_id === participation.id &&
              t.turn_type !== 'video_audio_on'
          );
          if (
            this.isStudentOnline(participation.user.id) &&
            participation.user.id !== this.currentSpeaker.user_id &&
            isInCircle.length === 0
          )
            onlineCount += 1;
        });
        return onlineCount;
      },
      isStudentInCircle: function () {
        return this.getCurrentDiscussion.turns_in_circle.map(
          (t) => t.participation.id && t.turn_type !== 'video_audio_on'
        );
      },
      usersInCircle: function () {
        if (this.getCurrentDiscussion.turns_in_circle.length) {
          return this.getCurrentDiscussion.turns_in_circle.filter(
            (t) => t.turn_type !== 'video_audio_on'
          );
        }
        return [];
      },
      currentSpeaker() {
        const speaker = this.getCurrentDiscussion.participations.find(
          (p) => p.user_id === this.getCurrentDiscussion.currently_active
        );
        const turn = this.getCurrentDiscussion.turns_in_circle.find(
          (t) =>
            t.participation.user.id ===
            this.getCurrentDiscussion.currently_active
        );
        if (speaker) {
          speaker.turn_type = turn ? turn.turn_type : '';
        }
        return speaker || {};
      },
      audioVideoIsActive() {
        return this.getCurrentDiscussion.audio_discussion_is_enabled;
      },
      discussionIsLive() {
        return this.getCurrentDiscussion.is_live;
      },
      studentsTappedIn() {
        let count = this.usersInCircle.length;
        if (this.getCurrentDiscussion.currently_active) {
          count = this.usersInCircle.length - 1;
          return count;
        }
        return count;
      },
    },
    props: {
      isFullscreen: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleOpenParticipantAssessment: async function(student) {
        const participation = await this.$store.dispatch('fetchParticipationSummary', student.id);
        this.$emit('openParticipantSidebar', true, participation);
        return;
      },
      removeDuplicadosEGuardarRemovidos(array) {
        const conjunto = {};
        const arraySemDuplicados = [];
        const elementosRemovidos = [];

        array.forEach((item) => {
          if (!conjunto[item]) {
            conjunto[item] = true;
            arraySemDuplicados.push(item);
          } else {
            elementosRemovidos.push(item);
          }
        });

        return { arraySemDuplicados, elementosRemovidos };
      },
      determineTurnTypeIconHTML(type) {
        let icon = `<i class="fas `;
        let img = `<img
                  class="h-4 w-4"
                  src="/static/live_discussion/ld_question_icon.svg"
                />`;
        switch (type) {
          case 'new_idea':
            icon += 'fa-play text-primary" ';
            break;
          case 'build_on':
            icon += 'fa-square text-green-700" ';
            break;
          case 'challenge':
            icon += 'fa-circle text-pinky" ';
            break;
          case 'question':
            img;
            break;
          case 'hand_raise':
            icon += 'fa-chalkboard-user text-orange" ';
            break;
          default:
            icon = '';
        }
        if (icon && type !== 'question') {
          icon += '></i>';
          return icon;
        } else if (img && type === 'question') {
          return img;
        } else {
          return '';
        }
      },
      isUserModerator(participationID) {
        const userModerator = this.getCurrentDiscussion.participations.find(
          (p) => p.id === participationID
        );
        if (userModerator && userModerator.is_moderator) return true;
        return false;
      },
      isStudentOnline: function (studentId) {
        return this.getCurrentDiscussion.users_present.includes(studentId);
      },
      studentInCircleTurnCount(participationID) {
        const p = this.getCurrentDiscussion.participations.find(
          (p) => p.id === participationID
        );
        if (p) {
          return p.turn_count;
        }
        return 0;
      },
      studentInCircleaudioIsEnabled(participationID) {
        const p = this.getCurrentDiscussion.participations.find(
          (p) => p.id === participationID
        );
        if (p) {
          return p.audio_is_enabled;
        }
        return undefined;
      },
      isStudentNotInCircle(user_id) {
        let isInCircle = this.getCurrentDiscussion.turns_in_circle.filter(
          (t) =>
            t.participation.user.id === user_id &&
            t.turn_type !== 'video_audio_on'
        );
        if (user_id !== this.currentSpeaker.user_id && !isInCircle.length)
          return true;
        return false;
      },
      openParticipantFromTapIn: function (studentCircleId) {
        this.studentsFiltered.map((student) => {
          if (student.user.id === studentCircleId)
            this.$emit('openParticipantSidebar', true, student);
        });
      },
      autoTurnSpeaker: async function () {
        EventBus.$emit('queueLoading', true);
        await this.$store
          .dispatch('autoTurnSpeaker', {
            discussion_id: this.getCurrentDiscussion.id,
            hand_raise_type: 'hand_raise_type',
          })
          .then((res) => {
            if (res.failedReason || res.error)
              EventBus.$emit('queueLoading', false);
          })
          .catch(() => EventBus.$emit('queueLoading', false));
      },
      removeSpeaker: async function (userId) {
        if (userId === this.getCurrentDiscussion.currently_active) {
          const participation = this.getCurrentDiscussion.participations.find(
            (x) => x.user_id === userId
          );
          if (this.audioVideoIsActive) {
            if (participation.audio_is_enabled)
              await toggleStudentParticipationAudio(
                this.$route.params.liveDiscussionID,
                participation.id
              );
            if (participation.video_is_enabled)
              await toggleStudentParticipationVideo(
                this.$route.params.liveDiscussionID,
                participation.id
              );
          }
          this.$store.dispatch('tapOut', {
            discussion_id: this.getCurrentDiscussion.id,
            user_id: userId,
            participation_id: participation.id,
          });
        }
      },
      removeAllTapIn: function () {
        const payload = {
          speaker_id: this.getCurrentDiscussion.currently_active,
          participants_in_queue: this.getCurrentDiscussion.queue.map(
            (q) => q.user_id
          ),
        };
        clearAllTapIns(this.getCurrentDiscussion.id, payload);
      },
      tapInByTeacher: function (userId) {
        this.tapin = true;
        addStudentToCircle(this.getCurrentDiscussion.id, userId)
          .then(({ data }) => {
            this.tapin = false;
            if (data) {
              if (
                this.getCurrentDiscussion.auto_turn &&
                !this.getCurrentDiscussion.currently_active &&
                !this.getCurrentDiscussion.queue.length
              ) {
                this.autoTurnSpeaker();
              }
            }
          })
          .catch((error) => {
            this.tapin = false;
            console.error(error);
          })
          .finally(() => (this.tapin = false));
      },
    },
  });
</script>
<style scoped>
.speaking::before,
.speaking::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border: 2px solid #38bdf8; /* lightBlue-400 */
  border-radius: 9999px;
  transform: translate(-50%, -50%);
  animation: pulse 1.5s infinite;
}

.speaking::after {
  animation-delay: 0.75s; /* segunda onda */
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.8;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.2);
    opacity: 0;
  }
}
  .max-height-list {
    max-height: calc(100vh - 243px);
    min-height: calc(100vh - 243px);
    overflow-y: scroll;
  }
  .max-height-list-fullscreen {
    max-height: calc(100vh - 94px);
    min-height: calc(100vh - 94px);
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// ListParticipantsCollapsed.vue?09bb2888